import {useAppContext, useUserContext} from "../../contexts";
import {api} from "../../services";
import {route} from "preact-router";

export const useNadBeneficiaryModal = (props) => {
    // Destructured props
    const {
        source,
        setSameBeneficiaryModalOpen,
        handleBeneficiarySkip
    } = props;

    // Retrieves the method to trigger the full page loader component
    const {setFullPageLoader} = useAppContext();
    // Flag to check whether user is signed in or not and cart data
    const [{sessionFormKey}, {}, {cartData}] = useUserContext();

    // Method to handle the budget cancel action
    const handleBudgetCancelAction = async () => {
        try {
            // Activates the full page loader component
            setFullPageLoader(true);

            // Actually performs the request to the backend
            let response = await api.post("/nad/nad/cancel", {
                form_key: sessionFormKey
            });

            // Checks for any errors
            if (response.data.error) {
                console.log("Error while canceling budget.");

                setFullPageLoader(false);
            }
        } catch (err) {
            console.log("Error while canceling budget: ", err);
        }
    }

    // Handles the button click
    const handleActionClick = async (props) => {
        // Destructured props
        const {action} = props;

        if (source === "beneficiariesStep") {
            if (action === "yes") {
                handleBeneficiarySkip("beneficiariesStep");
            }

            setSameBeneficiaryModalOpen(false);

            return;
        }

        // The path the user will be redirected to
        const targetPath =
            action === "no" ?
                `/nad${source === "self_service" ? "?source=self_service" : ""}` :
                `/nad?skip=true${source === "self_service" ? "&source=self_service" : ""}`;

        // Cancels the active budget if one exists
        if (cartData?.nadLock) {
            await handleBudgetCancelAction();

            // Performs a redirect refreshing the page
            window.location.href = targetPath;

            return;
        }

        // Performs a redirect without reloading the page
        route(targetPath);
    }

    return {
        handleActionClick
    }
}
